import { HttpResponseError } from 'src/service/backend/error/HttpResponseError'

export class AuthorizationError extends HttpResponseError {}
